import { EventEmitter, Injectable, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MisdatosProveedorService {

  @Output() msjActualizarDatos = new EventEmitter();

  constructor(private http: HttpClient) { }


    getMisDatosProveedor(cuit): Observable<any> {
        return this.http.get(`${environment.urlApi}proveedor/getData?cuit=${cuit}`);
    }
    getEmailProveedor(cuit): Observable<any> {
      return this.http.get(`${environment.urlApi}proveedor/emailProveedor?cuit=${cuit}`);
  }
    getlastLoginProveedor(cuit): Observable<any> {
      return this.http.get(`${environment.urlApi}proveedor/lastLogin?cuit=${cuit}`);
  }

    updateDatosProveedor(cuit, form: FormData): Observable<any> {
        return this.http.post(`${environment.urlApi}proveedor/updateDataProveedor?cuit=${cuit}`, form);
    }

    updateEmailProveedor(cuit, emailForm: FormData): Observable<any> {
      return this.http.post(`${environment.urlApi}proveedor/updateEmailProveedor?cuit=${cuit}`, emailForm);
  }
    updateEmailProveedorBySAB(emailForm:FormData): Observable<any> {
      return this.http.post(`${environment.urlApi}proveedor/updateEmailProveedor`, emailForm);
  }
    
}

